var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../../less/IdStyles";
import { selectActiveTutorialConfig } from "../../../../selectors/selectTutorial";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { BigCharacter } from "../../../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../../../generic/big-character/IdBigCharacter";
import { TextLoca } from "../../../generic/text/TextLoca";
import { actionTutorialHarvestClickAcre } from "../../actionTutorial";
var TutorialWelcomeDOM = /** @class */ (function (_super) {
    __extends(TutorialWelcomeDOM, _super);
    function TutorialWelcomeDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TutorialWelcomeDOM.prototype.render = function () {
        var _a = this.props, tutorialConfig = _a.tutorialConfig, onClick = _a.onClick;
        if (tutorialConfig === undefined) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: "tutorial-wrapper tutorial-wrapper__background", onClick: function () {
                onClick();
            } },
            React.createElement("div", { className: "flex" },
                React.createElement(BigCharacter, { idStyle: IdStyles.TutorialCharacterPlaceholder, className: "big-character-flip", name: IdBigCharacter.TessaLeftSide }),
                React.createElement("div", { className: "flex flex--auto flex--stacked flex--around" },
                    React.createElement("div", { className: "tutorial-balloon tutorial-balloon__aline " + IdStyles.TutorialBalloon },
                        React.createElement("div", { className: IdStyles.TextBoldAccent },
                            React.createElement(TextLoca, { id: IdLoca.quest_tutorial_welcome_title })),
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: tutorialConfig.idLocaDescription }))),
                    React.createElement("div", { className: "flex flex--guts tutorial-continue__button" },
                        React.createElement(TextLoca, { className: "" + IdStyles.HeadlineOne, id: IdLoca.tapToContinue_web }))))));
    };
    return TutorialWelcomeDOM;
}(React.Component));
var mapState = function (state) {
    var tutorialConfig = selectActiveTutorialConfig(state);
    return {
        tutorialConfig: tutorialConfig,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionTutorialHarvestClickAcre()); },
}); };
export var TutorialWelcome = connect(mapState, mapDispatch)(TutorialWelcomeDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/tutorial-welcome/TutorialWelcome.tsx
// module id = 1366
// module chunks = 3